import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function TeacherLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("dm_token", data.token);
      localStorage.setItem("dm_teacher", JSON.stringify(data.teacher));
      navigate("/teacher");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Přihlášení selhalo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 mb-6 text-slate-500 hover:text-slate-900 text-sm font-bold">
          ← Zpět na žákovský vstup
        </Link>
        <div className="bg-white border border-slate-200 rounded-lg p-8 shadow-sm">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-8 h-8 rounded-md bg-slate-900 text-white flex items-center justify-center font-black">D</div>
            <span className="font-heading font-black text-xl tracking-tight text-slate-900">digitální most</span>
          </div>
          <h1 className="text-2xl font-heading font-black tracking-tight text-slate-900 mt-4">Lektorská administrace</h1>
          <p className="text-sm text-slate-500 mt-1">Přihlas se pro založení session.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-slate-500">E-mail</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full border border-slate-200 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-slate-900"
                data-testid="teacher-email"
                required
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-wider text-slate-500">Heslo</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full border border-slate-200 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-slate-900"
                data-testid="teacher-password"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white font-bold rounded-md py-2.5 text-sm disabled:opacity-50"
              data-testid="teacher-submit"
            >
              {loading ? "Přihlašuji..." : "Přihlásit se"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
